import { getSessionSaga, reduceLoading, reduceOperation } from 'metrix-common3';
import { call, put } from 'redux-saga/effects';
import { getPolicy } from '../../actions/policy/getPolicy';
import { getPolicySummary } from '../../actions/policy/getPolicySummary';
import { reducePolicyAdjustments } from '../../actions/policy/reducePolicyAdjustments';

export function* applyPolicyAdjustmentChangesSaga(action) {
    try {
        yield put(reduceLoading({ code: 'applyPolicyAdjustmentChanges', value: true }));
        const session = yield getSessionSaga();

        const response = yield call(fetch, '/api/policyAdjustment/apply-changes', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                Accept: 'application/json',
                Authorization: session.authenticationToken.token,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(action.payload),
        });

        if (!response.ok) {
            console.error('Apply Policy Adjustment Changes API failed with status:', response.status);
            yield put(reduceLoading({ code: 'applyPolicyAdjustmentChanges', value: false }));
            return;
        }

        const result = yield call([response, 'json']);

        // Add operation code to identify which operation completed
        yield put(reduceOperation({ ...result.operation, code: 'applyPolicyAdjustmentChanges' }));
        yield put(reducePolicyAdjustments(result));

        // Refresh policySummary and policyTransaction after applying changes
        if (result.operation.status) {
            yield put(getPolicy());
            yield put(getPolicySummary());
        }

        yield put(reduceLoading({ code: 'applyPolicyAdjustmentChanges', value: false }));
    } catch (error) {
        console.log('Error while calling Apply Policy Adjustment Changes API - ', error);
        yield put(reduceLoading({ code: 'applyPolicyAdjustmentChanges', value: false }));
    } finally {
        yield put(reduceLoading({ code: 'applyPolicyAdjustmentChanges', value: false }));
    }
}
